/** Domain actions enforced server-side via requireAction(). */
export const AppAction = {
    RECEIPT_CREATE: "receipt.create",
    EXPENSE_CREATE: "expense.create",
    EXPENSE_SUBMIT: "expense.submit",
    EXPENSE_APPROVE: "expense.approve",
    EXPENSE_REJECT: "expense.reject",
    EXPENSE_PAY: "expense.pay",
    EXPENSE_REVERSE: "expense.reverse",
    TRANSFER_CREATE: "transfer.create",
    SETTINGS_MANAGE: "settings.manage",
    REPORT_EXPORT: "report.export",
    FILE_UPLOAD: "file.upload",
    FILE_DOWNLOAD: "file.download",
    AUDIT_READ: "audit.read",
};
//# sourceMappingURL=app-actions.js.map